<script lang="ts">
  import Blocks from "@components/blocks/Blocks.svelte";
  import { twJoin } from "tailwind-merge";

  export let blocks: any;
  export let column_width: {
    value: "20" | "25" | "33" | "40" | "50" | "60" | "66" | "75" | "80" | "100";
  };

  export let horizontal_alignment: { value: "start" | "center" | "end" } = {
    value: "start",
  };

  const columnWidthClasses = {
    "20": "md:w-1/5",
    "25": "md:w-1/4",
    "33": "md:w-1/3",
    "40": "md:w-2/5",
    "50": "md:w-1/2",
    "60": "md:w-3/5",
    "66": "md:w-2/3",
    "75": "md:w-3/4",
    "80": "md:w-4/5",
    "100": "md:w-full",
  };

  const horizontalAlignmentClasses = {
    start: "items-start",
    center: "items-center",
    end: "items-end",
  };

  export const type: "column" = "column";
  export const id: string = "";
</script>

<div
  class={twJoin(
    "w-full flex flex-col",
    columnWidthClasses[column_width.value],
    horizontalAlignmentClasses[horizontal_alignment?.value],
  )}
>
  <Blocks {blocks} />
</div>
